import React, { useState, useEffect, forwardRef } from "react";
import FullCalendar, { constrainPoint } from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import interactionPlugin from '@fullcalendar/interaction'; // a plugin!
import { ko } from "date-fns/locale";
import {
  Box, Select, MenuItem, FormControl, InputLabel, Dialog,
  AppBar, Toolbar, IconButton,
  Typography
} from "@mui/material";
import CenterSelect from "./CenterSelect";
import { configState, loginState } from "../lib/State";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";
import axios from "axios";
import get_token from "../lib/get_token";
import get_cid from "../lib/get_cid";
import moment from "moment";
import add_comma from "../lib/add_comma";
import remove_comma from "../lib/remove_comma";
import Slide from "@mui/material/Slide";
import CloseIcon from "@mui/icons-material/Close";
import pr from "../lib/pr";
import styled from "@emotion/styled";

// react-bootstrap-table-next
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

// 즐겨찾는 센터 
function SelectFCenter(props) {

    const {p_setFcid} = props;
    const [fcid, setFcid] = useState('');
    const [rows, setRows] = useState([]);
    const load_data = async () => {
      let result = await axios.post(configState.api + "/gympass_admin/center_list");
  
      // 두써킷 센터만
      result.data = result.data.filter(el => el.cid === 'CID00000009' || el.cid === 'CT17X10111035.huwy5');
      setRows(result.data);
    }
  
    useEffect(() => {
      load_data();
    }, []);
  
    return <FormControl sx={{ width: 200}} size="small">
      <InputLabel>즐겨찾는센터</InputLabel>
      <Select
        name="fcid"
        label="즐겨찾는센터"
        onChange={(e) => { 
          setFcid(e.target.value);
          p_setFcid(e.target.value);
        }}      
        value={fcid}
      >
        { rows.map((item, index) => {
          return <MenuItem key={index} value={item.cid}>{item.center}:{item.location}</MenuItem>
        }) }
      </Select>
    </FormControl>
  }

export default SelectFCenter;